import { render, staticRenderFns } from "./Designs.vue?vue&type=template&id=ff69b5f8&scoped=true"
import script from "./Designs.vue?vue&type=script&lang=js"
export * from "./Designs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff69b5f8",
  null
  
)

export default component.exports